import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { removeToast } from "store/toastsSlice";

import Button from "layout/atoms/Button";
import Icon from "layout/atoms/Icon";

import { ReactComponent as successSvg } from "assets/icons/all-done.svg";
import {
  ReactComponent as CloseSvg,
  ReactComponent as errorSvg,
} from "assets/icons/close.svg";
import { ReactComponent as infoSvg } from "assets/icons/info.svg";
import { ReactComponent as warningSvg } from "assets/icons/warning.svg";

import { Text, Wrapper } from "./styles";

const Toast = ({ data }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [active, setActive] = useState(false);
  const icons = {
    success: successSvg,
    error: errorSvg,
    info: infoSvg,
    warning: warningSvg,
  };

  const handleClose = useCallback(() => {
    setActive(false);
    setTimeout(() => dispatch(removeToast(data.id)), 500);
  }, [dispatch, data.id]);

  useEffect(() => {
    setTimeout(() => setActive(true), 100);
    setTimeout(() => handleClose(), 6000);
  }, [dispatch, handleClose]);

  return (
    <Wrapper active={active} type={data.type}>
      <div>
        <Icon src={icons[data.type]} />
        <Text type={data.type}>
          <h4>{data.title ? t(data.title) : t(`toasts.error.title`)}</h4>
          <p>
            {data.description ? t(data.description) : t(`toasts.error.title`)}
          </p>
        </Text>
      </div>
      <Button size="sm-square" color="blank" onClick={() => handleClose()}>
        <Icon src={CloseSvg} />
      </Button>
    </Wrapper>
  );
};

export default Toast;
